/* unplugin-vue-components disabled */import { render } from "./NavHeader.vue?vue&type=template&id=840cc030&scoped=true&ts=true"
import script from "./NavHeader.vue?vue&type=script&lang=ts"
export * from "./NavHeader.vue?vue&type=script&lang=ts"

import "./NavHeader.vue?vue&type=style&index=0&id=840cc030&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840cc030"],['__file',"src/components/nav-header/NavHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "840cc030"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('840cc030', __exports__)) {
    console.log('reload')
    api.reload('840cc030', __exports__)
  }
  
  module.hot.accept("./NavHeader.vue?vue&type=template&id=840cc030&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('840cc030', render)
  })

}


export default __exports__